import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ded36c74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-action" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = ["data-network", "data-fallback-provider"]

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useApprove } from '@/composables/approve';
import { useDates } from '@/composables/dates';
import { useClaimStore } from '@/store/claimStore';

interface ApproveSpendButtonProps {
  onSuccess?: () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ApproveSpendButton',
  props: {
    onSuccess: { type: Function }
  },
  setup(__props: any) {

const props = __props;

_useCssVars(_ctx => ({
  "1816dfe2": (_unref(store).clientColors.themePrimary)
}))



const store = useClaimStore();
const { claimStartDate, claimEndDate, getCalendarString } = useDates();

const isModalOpen = ref(false);
const showSubscribeWidget = ref(false);
const checkoutState = ref<'payment-method' | 'buy-with-eth' | 'buy-with-card' | 'success'>(
  'buy-with-eth'
);

const { approve, txState, isLoading } = useApprove({
  onSuccess: () => {
    // HACK: Need this since for some reason
    // our subscribe widget logic doesn't populate the widget when the modal opens
    setTimeout(() => {
      showSubscribeWidget.value = true;
    }, 0);

    isModalOpen.value = true;
    checkoutState.value = 'success';

    if (props.onSuccess) {
      props.onSuccess();
    }
  },
  onError: (error: any) => {
    console.log('Error approving spend', error);
  },
});

const approveERC20 = () => {
  approve(undefined);
};

const approveButtonLabel = computed(() => {
  return txState.value === 'confirming' ? 'Approving...' : `Approve ${store.erc20Symbol}`;
});

// Need this to make sure the modal height is correct on Safari
const vh95 = ref('0px');

const setMaxHeight = () => {
  vh95.value = window.innerHeight * 0.95 + 'px';
};

onMounted(() => {
  setMaxHeight();
  window.addEventListener('resize', setMaxHeight);
  // email.value = tryGetLocalStorage(CROSSMINT_EMAIL_LOCAL_STORAGE_KEY);
});

onUnmounted(() => {
  window.removeEventListener('resize', setMaxHeight);
});

return (_ctx: any,_cache: any) => {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).isConnected)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: approveERC20,
          class: "campaign-buy-button",
          disabled: 
        _unref(store).isLoadingWeb3State ||
        _unref(store).isDelegationLoading ||
        _unref(store).isSoldOut ||
        _unref(store).status === 'not-started' ||
        _unref(store).status === 'ended' ||
        _unref(txState) === 'confirming' ||
        _unref(isLoading)
      
        }, [
          (_unref(store).isLoadingWeb3State || _unref(store).isDelegationLoading)
            ? (_openBlock(), _createBlock(_component_Spinner, {
                key: 0,
                dark: ""
              }))
            : (_unref(store).status === 'not-started')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Drops " + _toDisplayString(_unref(getCalendarString)(_unref(claimStartDate))), 1))
              : (_unref(store).status === 'ended')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Ended " + _toDisplayString(_unref(getCalendarString)(_unref(claimEndDate))), 1))
                : (_unref(store).isSoldOut)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Sold out"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(approveButtonLabel.value), 1))
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          "data-widget": "m-connect",
          "data-grant-type": "signature",
          "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
          "data-app-name": "Manifold Claims",
          "data-delay-auth": "always",
          "data-wallet-connect-project-id": "ca03bf2709bfa142a2d9adb0d6e99e7f",
          "data-enable-network-switching": true,
          "data-network": _unref(store).networkId,
          "data-browser-provider-ignore-disconnect": true,
          "data-fallback-provider": _unref(store).fallbackProvider ? _unref(store).fallbackProvider : undefined,
          "data-multi": "true",
          "data-message": "Please sign this message to confirm your wallet address"
        }, null, 8, _hoisted_7))
  ]))
}
}

})